// @storybook-skip: thin container over FaqsList — reads store and filters by locale
import i18n from "@helpers/lib/i18n";
import { useAppStore } from "@hooks/useAppStore";
import FaqsList from "@memorang/ui/components/FaqsList";

const FaqsContainer = () => {
	const faqs = useAppStore((store) => store.app.accountSettings?.faqs);
	const appFont = useAppStore((store) => store.app.font) || "opensans";

	const sortedFaqs = faqs?.sort((a, b) => a.order - b.order);

	const filteredFaqs =
		sortedFaqs?.filter((faq) => faq.locale === i18n.language) ?? [];

	return <FaqsList faqs={filteredFaqs} appFont={appFont} />;
};

export default FaqsContainer;
